import { render, staticRenderFns } from "./templateTwo.vue?vue&type=template&id=62ba259b&scoped=true"
import script from "./templateTwo.vue?vue&type=script&lang=js"
export * from "./templateTwo.vue?vue&type=script&lang=js"
import style0 from "./templateTwo.vue?vue&type=style&index=0&id=62ba259b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ba259b",
  null
  
)

export default component.exports